import React from 'react';
import { PropTypes } from 'prop-types';
import { injectIntl } from 'react-intl';

import { history } from 'containers/App';
import LocalisedMessage from 'components/Common/LocalisedMessage';

import ErrorPage from 'components/Errors/ErrorPage';

const UnsupportedError = ({ titleTextId, buttonTextId }) => <ErrorPage
  title="Unsupported"
  titleTextId={ titleTextId }
  type="unsupported"
  showButton
  buttonText="Exit"
  buttonTextId={ buttonTextId }
  onButtonClick={ () => { history.push('/'); window.location.reload(); } }
>
  <p><LocalisedMessage id="unsupported.content" /></p>
</ErrorPage>;

UnsupportedError.propTypes = {
  titleTextId: PropTypes.string,
  buttonTextId: PropTypes.string
};

UnsupportedError.defaultProps = {
  titleTextId: 'unsupported.title',
  buttonTextId: 'unsupported.buttonText'
};

export default injectIntl(UnsupportedError);
